import { stereoAcuityInstruction } from "@constants/instructionConstants";
import { virtualAssistanceStereoAcuityConfig } from "@constants/virtualAssistanceConstants";
import {
  AvailablePreTestConfigurationOptions,
  TestType,
  EyeType,
  TestConfiguration,
  TestCategory,
  WaitDuration,
  TestUIConfiguration,
} from "types/testTypes";
import { CATEGORY_VERSION_MAP, TEST_TYPE_VERSION_MAP } from "../versionConstants";
import {
  AVAILABLE_EYE_OPTIONS_BINOCULAR,
  AVAILABLE_VIRTUAL_ASSISTANT_OPTIONS,
} from "../configurationHelperConstants";

export const availableStereoAcuityTestConfigurationOptions: AvailablePreTestConfigurationOptions = {
  testTypes: {
    configurationFieldName: "testType",
    choices: [
      { validSinceVersion: TEST_TYPE_VERSION_MAP[TestType.Staircase], value: TestType.Staircase },
    ],
    isMandatory: true,
    validSinceVersion: CATEGORY_VERSION_MAP[TestCategory.StereoAcuity],
  },
  eyeConfigurationOptions: { ...AVAILABLE_EYE_OPTIONS_BINOCULAR },
  languageOptions: null,
  virtualAssistantOptions: { ...AVAILABLE_VIRTUAL_ASSISTANT_OPTIONS },
  testSpeedOptions: null,
};
export const stereoAcuityTestConfiguration: TestConfiguration = {
  name: TestCategory.StereoAcuity,
  testType: TestType.Staircase,
  eyeConfiguration: {
    eyeType: EyeType.BothEye,
    isCalibrationNeeded: false,
    autoPauseForGaze: false,
    isTwoScreenFixationEnabled: true,
    isBackToBackEyeTest: false,
  },
  testSpeed: WaitDuration.Standard,
  testLanguage: null,
  virtualAssistanceConfig: virtualAssistanceStereoAcuityConfig,
  isPressToStartEnabled: true,
};

export const stereoAcuityUIConfiguration: TestUIConfiguration = {
  showProgressBar: true,
  instructions: stereoAcuityInstruction,
};
